import { DefaultState, DropdownItem } from 'store/types';

export const GET_AUTOMATED_REPORTS_REQUEST = 'GET_AUTOMATED_REPORTS_REQUEST';
export const GET_AUTOMATED_REPORTS_SUCCESS = 'GET_AUTOMATED_REPORTS_SUCCESS';
export const GET_AUTOMATED_REPORTS_FAILURE = 'GET_AUTOMATED_REPORTS_FAILURE';


export interface GetAutomatedReportsParams {
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface AutomatedReportBaseData {
  id: string;
  reportType: string;
  requestedDates: string;
  recipientsEmails: string[];
  weekDays: string[];
  sendTime: string;
}

export interface GetAutomatedReportsRow extends AutomatedReportBaseData { }

export interface GetAutomatedReportRow extends AutomatedReportBaseData {
  reportType: string;
  requestedDates: string;
  recipientsEmails: string[];
  weekDays: string[];
  sendTime: string;
}

export interface GetAutomatedReportsData {
  rows: GetAutomatedReportsRow[];
  totalCount: number;
  reportTypesSelectList?: DropdownItem[];
  reportDatesSelectList?: DropdownItem[];
  weekDaysSelectList?: DropdownItem[];
  userEmailsSelectList?: DropdownItem[];
}

export type GetAutomatedReportsState = DefaultState & {
  contents?: GetAutomatedReportsData;
};

interface GetAutomatedReportsRequest {
  type: typeof GET_AUTOMATED_REPORTS_REQUEST;
}

interface GetAutomatedReportsSuccess {
  type: typeof GET_AUTOMATED_REPORTS_SUCCESS;
  contents: GetAutomatedReportsData;
}

interface GetAutomatedReportsFailure {
  type: typeof GET_AUTOMATED_REPORTS_FAILURE;
}

export type GetAutomatedReportsActionTypes = GetAutomatedReportsRequest | GetAutomatedReportsSuccess | GetAutomatedReportsFailure;